import Car0 from "../assets/images/common/minicars/png/Car(0).png";
import Car1 from "../assets/images/common/minicars/png/Car(1).png";
import Car2 from "../assets/images/common/minicars/png/Car(2).png";
import Car3 from "../assets/images/common/minicars/png/Car(3).png";
import Car4 from "../assets/images/common/minicars/png/Car(4).png";
import Car5 from "../assets/images/common/minicars/png/Car(5).png";
import Car6 from "../assets/images/common/minicars/png/Car(6).png";
import Car7 from "../assets/images/common/minicars/png/Car(7).png";
import Car8 from "../assets/images/common/minicars/png/Car(8).png";
import Car9 from "../assets/images/common/minicars/png/Car(9).png";
import badImg from "../assets/images/common/badImg.png";
import place1 from "../assets/images/chart/png/place 1.png";
import place2 from "../assets/images/chart/png/place 2.png";
import place3 from "../assets/images/chart/png/place 3.png";
import placeTop1 from "../assets/images/chart/png/place championship 1.png";
import placeTop2 from "../assets/images/chart/png/place championship 2.png";
import placeTop3 from "../assets/images/chart/png/place championship 3.png";
import softTyre from "../assets/images/chart/png/softTyre.png";
import mediumTyre from "../assets/images/chart/png/mediumTyre.png";
import hardTyre from "../assets/images/chart/png/hardTyre.png";
import intermediateTyre from "../assets/images/chart/png/IntermediateTyre.png";
import wetTyre from "../assets/images/chart/png/wetTyre.png";
import gridFlag from "../assets/images/chart/svg/gridFlag.svg";
import whiteMinus from "../assets/images/common/icons/whiteMinus.svg";
import whitePlus from "../assets/images/common/icons/whitePlus.svg";
import fastestLap from "../assets/images/chart/png/fastestLap.png";
import pitstop from "../assets/images/chart/png/pitstop.png";
import accident from "../assets/images/chart/png/accident.png";
import mechanical from "../assets/images/chart/png/mechanical.png";
import stop from "../assets/images/chart/png/stop.png";
import greenArrow from "../assets/images/chart/png/greenArrow.png";
import grayArrow from "../assets/images/chart/png/grayArrow.png";
import redArrow from "../assets/images/chart/png/redArrow.png";
import laurel from "../assets/images/chart/png/laurel.png";
import flagExmp from "../assets/images/common/flagExample.svg";
import photoExmp from "../assets/images/profile/defaultPhoto.jpg";
import legend from "../assets/images/chart/png/legendHorizontal.png";
import { createFFmpeg } from "@ffmpeg/ffmpeg";
import { createHiDPICanvas } from "./canvasesUtils";

const RecordRTC = require("recordrtc");

export const getCookie = (name) => {
  let matches = document.cookie.match(
    new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)")
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
};
export const checkKeyExistence = () => getCookie("api-key") !== undefined;

export const colors = [
  "0,0,0",
  "255,204,0",
  "0,0,255",
  "153,51,0",
  "51,204,255",
  "255,255,0",
  "255,0,0",
  "255,0,204",
  "255,51,0",
  "224,167,107",
  "255,170,31",
];

export const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
export const isTouch = "ontouchstart" in document.documentElement;
export const isSafari = /Safari/i.test(window.navigator.userAgent) && !/Hrome/i.test(window.navigator.userAgent);
export const isHexColor = (color) => /[0-9A-F]{6}$/i.test(color);
export const hexToRgb = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? `${parseInt(result[1], 16)},${parseInt(result[2], 16)},${parseInt(result[3], 16)}` : null;
};

export const upperFstLetter = (string) => {
  if (typeof string !== "string") return undefined;
  return string.charAt(0).toUpperCase() + string.slice(1);
};
export const getFormattedDate = (date) => {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const m = new Date(date);
  return (
    ("0" + m.getUTCHours()).slice(-2) +
    "/" +
    ("0" + m.getUTCMinutes()).slice(-2) +
    " | " +
    ("0" + m.getUTCDate()).slice(-2) +
    "." +
    monthNames[m.getUTCMonth()] +
    "." +
    m.getUTCFullYear()
  );
};
export const getDateDiffStr = (startInt, endInt) => {
  const start = new Date(startInt);

  const sYear = start.getFullYear();
  const sMonth = new Intl.DateTimeFormat("en", { month: "short" }).format(start);
  const sDay = start.getDate();

  if (startInt === endInt) return `${sDay} ${sMonth} ${sYear}`;

  const end = new Date(endInt);

  const eYear = end.getFullYear();
  const eMonth = new Intl.DateTimeFormat("en", { month: "short" }).format(end);
  const eDay = end.getDate();

  if (sYear !== eYear) return `${sDay} ${sMonth} ${sYear} - ${eDay} ${eMonth} ${eYear}`;
  if (sMonth !== eMonth) return `${sDay} ${sMonth} - ${eDay} ${eMonth} ${eYear}`;
  if (sDay !== eDay) return `${sDay} - ${eDay} ${eMonth} ${eYear}`;
};
export const getCoords = (ref) => {
  let box = ref.current.getBoundingClientRect();
  return {
    top: box.top + window.pageYOffset,
    left: box.left + window.pageXOffset,
  };
};
const getWindowSize = () => {
  if (isTouch) {
    return {
      widthWithScroll: document.body.clientWidth,
      width: document.body.clientWidth,
      height: document.body.clientHeight,
    };
  }
  return {
    widthWithScroll: window.innerWidth,
    width: document.body.clientWidth,
    height: document.body.clientHeight,
  };
};
export const getWidths = () => {
  const wSize = getWindowSize();
  return {
    windowWidth: wSize.widthWithScroll,
    visibleWidth: wSize.width,
    width: wSize.width - (wSize.width > 1000 ? 65 : wSize.width > 500 ? 30 : 0),
  };
};
export const getStageTitle = (name) => {
  let result = "";
  if (name.toLowerCase().includes("practice")) {
    result = "P";
    const r = name.match(/\d+/);
    r !== null && (result += r[0]);
    return result;
  }
  if (name.toLowerCase().includes("qualifying")) {
    result = "Q";
    const r = name.match(/\d+/);
    r !== null && (result += r[0]);
    return result;
  }
  return name.toUpperCase();
};
export const getCurEventForProfile = (data, ind) => {
  let raceCount = 0;
  let curYear = 0;
  let curEventId = undefined;
  for (let i = 0; i < data.seasons.length; i++) {
    const s = data.seasons[i];
    if (raceCount + s.races.length <= ind) {
      raceCount += s.races.length;
    } else {
      const race = s.races[ind - raceCount];
      curYear = s.year;
      curEventId = race.event.uuid;
      break;
    }
  }
  return { year: curYear, eventId: curEventId };
};

const setSvgSize = (svgAsText) => {
  // получаю svg как текст, узнаю размеры viewBox
  const regex = /viewBox="(([0-9.]*)\s)+(([0-9.]*))"/g;
  const match = regex.exec(svgAsText);

  // добавляю ширину и высоту, взятые из viewBox, картинкам
  if (match !== null) {
    svgAsText = svgAsText
      .substring(svgAsText.indexOf("<svg"), svgAsText.length)
      .replace("<svg", `<svg width="${match[2]}" height="${match[4]}"`);
  }

  // создаю url на получившуюся картинку, саздаю dom елемент и пушу в массив
  let blob = new Blob([svgAsText], { type: "image/svg+xml" });
  return URL.createObjectURL(blob);
};
export const loadImage = (src, w = 100) =>
  new Promise((resolve) => {
    const tmpCanvas = document.createElement("canvas");
    const tmpCtx = tmpCanvas.getContext("2d");

    const img = new Image();
    img.src = src;
    img.crossOrigin = "Anonymous";
    img.onload = () => {
      const h = (w * img.height) / img.width;
      tmpCanvas.width = w;
      tmpCanvas.height = h;
      tmpCtx.drawImage(img, 0, 0, w, h);
      resolve(tmpCanvas);
    };
    img.onerror = (e) => {
      console.log(e);
      resolve(null);
    };
  });
export const getRoundedPhoto = (src) =>
  new Promise((resolve) => {
    const tmpCanvas = document.createElement("canvas");
    const tmpCtx = tmpCanvas.getContext("2d");

    const img = new Image();
    img.src = src;
    img.crossOrigin = "Anonymous";
    img.onload = () => {
      const size = Math.min(img.width, img.height);
      tmpCanvas.width = size;
      tmpCanvas.height = size;
      const r = size / 2;

      tmpCtx.beginPath();
      tmpCtx.arc(r, r, r, 0, Math.PI * 2, true);
      tmpCtx.closePath();
      tmpCtx.clip();

      const x = (size - img.width) / 2;
      const y = (size - img.height) / 2;
      tmpCtx.drawImage(img, x, y, img.width, img.height);

      resolve(tmpCanvas);
    };
    img.onerror = () => resolve(null);
  });
export const getIcons = async () => {
  const icons = {
    cars: [],
    cups: [],
    arrows: [],
  };
  const iconsLinks = [
    Car0,
    Car1,
    Car2,
    Car3,
    Car4,
    Car5,
    Car6,
    Car7,
    Car8,
    Car9,
    place1,
    place2,
    place3,
    placeTop1,
    placeTop2,
    placeTop3,
    greenArrow,
    grayArrow,
    redArrow,
    badImg,
    softTyre,
    mediumTyre,
    hardTyre,
    intermediateTyre,
    wetTyre,
    gridFlag,
    whiteMinus,
    whitePlus,
    fastestLap,
    pitstop,
    accident,
    mechanical,
    stop,
    laurel,
    flagExmp,
  ];
  const result = await Promise.all(iconsLinks.map((link) => loadImage(link)));
  await result.push(getRoundedPhoto(photoExmp));

  icons.cars = result.slice(0, 10);
  icons.cups = result.slice(10, 13);
  icons.cupsTop = result.slice(13, 16);
  icons.arrows = result.slice(16, 19);
  icons.badImg = result[19];
  icons.softTyre = result[20];
  icons.mediumTyre = result[21];
  icons.hardTyre = result[22];
  icons.intermediateTyre = result[23];
  icons.wetTyre = result[24];
  icons.gridFlag = result[25];
  icons.whiteMinus = result[26];
  icons.whitePlus = result[27];
  icons.fastestLap = result[28];
  icons.pitstop = result[29];
  icons.accident = result[30];
  icons.mechanical = result[31];
  icons.other = result[32];
  icons.laurel = result[33];
  icons.flagExmp = result[34];

  icons.photoExmp = await getRoundedPhoto(photoExmp);

  return icons;
};
export const getPictures = async (sources, round = false) => {
  const links = [...new Set(sources.map((s) => s.src))];

  const imgs = await Promise.all(
    links.map((c) => {
      if (!c) return undefined;
      return fetch(c)
        .then((r) => {
          if (r.url.endsWith(".svg")) {
            return r.text().then((r) => (round ? getRoundedPhoto(r) : loadImage(setSvgSize(r))));
          } else return round ? getRoundedPhoto(r.url) : loadImage(r.url);
        })
        .catch((e) => console.log(e));
    })
  );

  return sources.map((s) => {
    const linkInd = links.findIndex((l) => l === s.src);
    s.img = imgs[linkInd];
    return s;
  });
};
export const getResized = ({ img, h, w }) => {
  const ratio = img.width / img.height;
  return h === undefined ? w * ratio : h * ratio;
};

export const downloadData = (url, name) => {
  const link = document.createElement("a");
  link.download = name;
  link.href = url;
  link.click();
  link.remove();
};

let ffmpegError = undefined;
let ffmpegLoaded = false;
const ffmpeg = createFFmpeg({ log: false });
const loader = ffmpeg
  .load()
  .then(() => (ffmpegLoaded = true))
  .catch((e) => {
    console.error(e);
    ffmpegError = true;
  });
const convertStreams = async (sourceBuffer) => {
  console.log("converting...");
  const [ab, loaded] = await Promise.all([sourceBuffer.arrayBuffer(), loader]);
  ffmpeg.FS("writeFile", "input.webm", new Uint8Array(ab, 0, sourceBuffer.byteLength));
  const cmd = "-i input.webm -c:v mpeg4 -q:v 1 -r 60 output.mp4".split(" ");
  await ffmpeg.run(...cmd);
  console.log("converted!");
  return ffmpeg.FS("readFile", "output.mp4");
};
export const record = ({ placeHolderRef, canvas, updCanvas, title = "Race" }) => {
  if (isSafari || ffmpegError) {
    alert("Your browser does not support recording");
    return new Promise((resolve) => {
      resolve();
    });
  }
  if (!ffmpegLoaded) {
    alert("I'm getting ready. Try in a few seconds");
    return new Promise((resolve) => {
      resolve();
    });
  }
  placeHolderRef.textContent = "Recording";
  const recorder = new RecordRTC(canvas, { disableLogs: true, type: "canvas" });
  recorder.startRecording();
  let frameID;
  return new Promise((resolve) => {
    const looper = () => {
      const progress = updCanvas();
      if (progress === 1) {
        setTimeout(() => {
          cancelAnimationFrame(frameID);
          recorder.stopRecording(async () => {
            placeHolderRef.textContent = "Converting to mp4";
            convertStreams(recorder.getBlob()).then((result) => {
              const blob = new File([result], "race.mp4", {
                type: "video/mp4",
              });

              downloadData(URL.createObjectURL(blob), title + ".mp4");
              resolve();
            });
          });
        }, 1000);
      }
      frameID = requestAnimationFrame(looper);
    };
    frameID = requestAnimationFrame(looper);
  });
};
export const recordWidget = async ({
  beforeRecord,
  afterRecord,
  canvasesBlock,
  title,
  countryFlag,
  span,
  logoSrc,
  BGColor,
  mainColor,
  ffl,
  replay,
  updCanvas,
  drawLegend = true,
}) => {
  const sv = { w: 1920, h: 1080 };
  const head = 60;
  const footer = drawLegend ? 60 : 0;

  const screen = document.createElement("canvas");
  beforeRecord({ ...sv, h: sv.h - (head + footer) });
  canvasesBlock.style.opacity = "0.3";
  span.style.opacity = "1";

  const ctx = createHiDPICanvas(sv.w, sv.h, screen, false).getContext("2d");
  const logoEl = await loadImage(logoSrc, 300);
  ctx.fillStyle = BGColor;
  ctx.font = `normal 600 normal 30px ${ffl}`;
  ctx.textBaseline = "middle";
  ctx.fillRect(0, 0, sv.w, head);
  ctx.fillRect(0, sv.h - footer, sv.w, footer);
  // header
  if (countryFlag) ctx.drawImage(countryFlag, 10, head / 2 - 20, 40, 40);
  ctx.fillStyle = mainColor;
  // if (title.includes('\n')) {
  //   const lines = title.split('\n');
  //   for (let i = 0; i < lines.length; i++)
  //     ctx.fillText(lines[i].toUpperCase(), countryFlag ? 80 : 10, (i + 1) * 32 + 5 );
  // } else
  ctx.fillText(title.toUpperCase(), countryFlag ? 80 : 10, head / 2 + 4);
  const logoSize = {
    w: (head - 20) * (logoEl.width / logoEl.height),
    h: head - 20,
  };
  ctx.drawImage(logoEl, sv.w - logoSize.w - 10, head / 2 - logoSize.h / 2, logoSize.w, logoSize.h);

  if (drawLegend) {
    // legend
    const legendEl = await loadImage(legend, 1920);
    const legendSize = {
      w: footer * (legendEl.width / legendEl.height),
      h: footer,
    };
    if (legendSize.w > sv.w) {
      legendSize.w = sv.w - 10;
      legendSize.h = legendSize.w * (legendEl.height / legendEl.width);
    }
    ctx.drawImage(legendEl, 0, sv.h - footer + legendSize.h / 4, legendSize.w, legendSize.h);
  }

  replay();
  record({
    placeHolderRef: span,
    canvas: screen,
    updCanvas: () => updCanvas(ctx, head, footer),
    title,
  }).then(() => {
    canvasesBlock.style.opacity = "1";
    span.style.opacity = "0";
    afterRecord();
  });
};

export const sendError = (e) => {
  console.error(
    `%c ${e.name}${e.message ? ": " + e.message : ""}`,
    "background: #f00; color: #fff",
    e.stack ? e.stack : ""
  );
  window?.parent?.postMessage({ name: e?.name, message: e?.message, stack: e?.stack, critical: true }, "*");
};
